export const deleteWorkCenterState = {
	workCenters: null,
	error: null,
	errorShow: false,
	loading: false,
};
